module.exports = __webpack_public_path__ + "static/media/bg-kiosk-beranda.deb4c628.png";